const getDistance = (lat1, lon1, lat2, lon2) => {
  const R = 6371e3 // metres
  const w1 = lat1 * Math.PI / 180 // w, λ in radians
  const w2 = lat2 * Math.PI / 180
  const dw = (lat2 - lat1) * Math.PI / 180
  const dλ = (lon2 - lon1) * Math.PI / 180

  const a = Math.sin(dw / 2) * Math.sin(dw / 2) +
            Math.cos(w1) * Math.cos(w2) *
            Math.sin(dλ / 2) * Math.sin(dλ / 2)
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))

  return (R * c / 1000) // in kilometres
}

module.exports = { getDistance }
